import type { Config } from '@/shared/graphql/legacy/generated'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useConfigStore = defineStore('config', () => {
  const config = ref<Config | null>(null)

  const setConfig = (configData: Config) => {
    config.value = configData
  }

  return {
    config,
    setConfig,
  }
})
